import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { IBulkChangeTrackerTrafficSourcePayload } from '../types';
import {
  AFFILIATE_BULK_CHANGE_TRACKER_TRAFFIC_SOURCE_API_URL,
  AFFILIATE_BULK_CHANGE_TRACKER_TRAFFIC_SOURCE_MUTATION,
  AFFILIATE_TRACKERS_SETTINGS_LIST_QUERY,
  AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS,
} from '../constants';

export default function useBulkChangeTrackerTrafficSourceMutation(): IContextMutationResult<void, Error, IBulkChangeTrackerTrafficSourcePayload> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IBulkChangeTrackerTrafficSourcePayload>({
    mutationKey: [AFFILIATE_BULK_CHANGE_TRACKER_TRAFFIC_SOURCE_MUTATION],
    mutationFn: ({ id, ...payload }) => fetchPut<void>(
      AFFILIATE_BULK_CHANGE_TRACKER_TRAFFIC_SOURCE_API_URL,
      payload,
      {
        permission: AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS.CHANGE_TRAFFIC_SOURCE,
        urlParams: {
          id,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [AFFILIATE_TRACKERS_SETTINGS_LIST_QUERY] });
      displayPresetToast('edited');
    },
  });
}
